import React from "react";
import { Datagrid, List, TextField, SimpleList } from "react-admin";
import ExecuteReport from "./ExecuteReport";
import permissions from "app/permissions";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";

import { MobileListRow } from "features/MobileListRow";
import SecuredComponent from "server/security/SecuredComponent";

const ReportsList = ({ category }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      exporter={false}
      filter={{ category }}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.name }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Описание", value: record.displayName }]} />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <SecuredComponent permission={permissions.canGenerateReports}>
                  <ExecuteReport />
                </SecuredComponent>
              </div>
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          resource="_"
        >
          <TextField
            source="name"
            label="Име"
            sortable={false}
          />
          <TextField
            source="displayName"
            label="Описание"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canGenerateReports}>
            <ExecuteReport />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ReportsList;
